'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconWebviCustom, iconWebviCustomTag } from '@ni/nimble-components/dist/esm/icons/webvi-custom';
import { wrap } from '../../utilities/react-wrapper';

export type { IconWebviCustom };
export { iconWebviCustomTag };
export const NimbleIconWebviCustom = wrap(IconWebviCustom);